export const CLEAR_CANVAS = "CLEAR_CANVAS";
export const HISTORY_BACK = "HISTORY_BACK";
export const HISTORY_FORWARD = "HISTORY_FORWARD";
export const HISTORY_DRAW_END = "HISTORY_DRAW_END";

export const HISTORY_SAVE = "HISTORY_SAVE";
export const HISTORY_LOAD = "HISTORY_LOAD";
export const PUBLISH = "PUBLISH";
export const PUBLISH_DATA = "PUBLISH_DATA";
export const TO_FRONT = "TO_FRONT";
export const CANCEL_TEXT_EDIT = "CANCEL_TEXT_EDIT";
export const COMPLETE_TEXT_EDIT = "COMPLETE_TEXT_EDIT";

/**
 * StageをRedrawする
 */
export const REDRAW = "REDRAW";

/**
 * リセット(描き直し)
 * @type {string}
 */
export const RESET = "RESET";
/**
 * タブレットで描きこみ終了時
 * @type {string}
 */
export const END_TABLET_DRAW = "END_TABLET_DRAW";
